import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_BASE = "https://backend.alephmedia.ro/api";

const Account = () => {
    const [user, setUser] = useState(null);
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [form, setForm] = useState({ name: '', email: '' });
    const [passwordForm, setPasswordForm] = useState({ old_password: '', password: '', password_confirmation: '' });
    const navigate = useNavigate();

    useEffect(() => {
        fetchAccount();
        fetchPayments();
    }, []);

    const fetchAccount = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${API_BASE}/account`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
            });
            const data = await res.json();
            if (data.success) {
                setUser(data.data);
                setForm({ name: data.data.name, email: data.data.email });
            } else {
                setUser(null);
            }
        } catch (e) {
            setUser(null);
        }
        setLoading(false);
    };

    const fetchPayments = async () => {
        if (!user) return;
        try {
            const res = await fetch(`${API_BASE}/account/payments`, {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
            });
            const data = await res.json();
            if (data.success) {
                setPayments(data.data);
            }
        } catch (e) {
            // ignorăm pentru moment
        }
    };

    const handleUpdate = async (e) => {
        e.preventDefault();
        setError(null); setSuccess(null);
        try {
            const res = await fetch(`${API_BASE}/account/update`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(form)
            });
            const data = await res.json();
            if (data.success) {
                setSuccess('Datele au fost actualizate!');
                setUser(data.data);
            } else {
                setError(data.message);
            }
        } catch (e) {
            setError('Eroare la actualizare date.');
        }
    };

    const handlePasswordChange = async (e) => {
        e.preventDefault();
        setError(null); setSuccess(null);
        try {
            const res = await fetch(`${API_BASE}/account/change-password`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('authToken')}`
                },
                body: JSON.stringify(passwordForm)
            });
            const data = await res.json();
            if (data.success) {
                setSuccess('Parola a fost schimbată!');
                setPasswordForm({ old_password: '', password: '', password_confirmation: '' });
            } else {
                setError(data.message);
            }
        } catch (e) {
            setError('Eroare la schimbarea parolei.');
        }
    };

    const handleCancelSubscription = async () => {
        setError(null); setSuccess(null);
        try {
            const res = await fetch(`${API_BASE}/account/cancel-subscription`, {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${localStorage.getItem('authToken')}` }
            });
            const data = await res.json();
            if (data.success) {
                setSuccess('Subscripția a fost anulată!');
                fetchAccount();
            } else {
                setError(data.message);
            }
        } catch (e) {
            setError('Eroare la anularea subscripției.');
        }
    };

    if (loading) return <div className="auth-wrapper"><div className="auth-container">Se încarcă...</div></div>;

    return (
        <div className="auth-wrapper">
            <div className="auth-container">
                <div className="auth-logo">
                    <a href="/">
                        <img src="/assets/img/logo-aleph-rosu.png" alt="Aleph" />
                    </a>
                </div>
                <h1 className="auth-title">Contul meu</h1>
                
                {!user ? (
                    <div className="auth-message">
                        <p>Aceasta este pagina contului tău. Te rog să te autentifici sau să te înregistrezi pentru a-ți administra contul.</p>
                        <div className="auth-buttons">
                            <button onClick={() => navigate('/login')} className="auth-button primary">Autentificare</button>
                            <button onClick={() => navigate('/register')} className="auth-button secondary">Înregistrare</button>
                        </div>
                    </div>
                ) : (
                    <>
                        {error && <p className="error">{error}</p>}
                        {success && <p className="success">{success}</p>}
                        
                        <div className="form-section">
                            <h2>Date personale</h2>
                            <form onSubmit={handleUpdate}>
                                <div className="form-row">
                                    <input
                                        type="text"
                                        value={form.name}
                                        onChange={e => setForm({ ...form, name: e.target.value })}
                                        placeholder="Nume complet"
                                        className="form-field"
                                    />
                                </div>
                                <div className="form-row">
                                    <input
                                        type="email"
                                        value={form.email}
                                        onChange={e => setForm({ ...form, email: e.target.value })}
                                        placeholder="Email"
                                        className="form-field"
                                    />
                                </div>
                                <div className="form-row">
                                    <button type="submit" className="form-submit">Actualizează datele</button>
                                </div>
                            </form>
                        </div>

                        <div className="form-section">
                            <h2>Schimbă parola</h2>
                            <form onSubmit={handlePasswordChange}>
                                <div className="form-row">
                                    <input
                                        type="password"
                                        value={passwordForm.old_password}
                                        onChange={e => setPasswordForm({ ...passwordForm, old_password: e.target.value })}
                                        placeholder="Parola veche"
                                        className="form-field"
                                    />
                                </div>
                                <div className="form-row">
                                    <input
                                        type="password"
                                        value={passwordForm.password}
                                        onChange={e => setPasswordForm({ ...passwordForm, password: e.target.value })}
                                        placeholder="Parola nouă"
                                        className="form-field"
                                    />
                                </div>
                                <div className="form-row">
                                    <input
                                        type="password"
                                        value={passwordForm.password_confirmation}
                                        onChange={e => setPasswordForm({ ...passwordForm, password_confirmation: e.target.value })}
                                        placeholder="Confirmă parola nouă"
                                        className="form-field"
                                    />
                                </div>
                                <div className="form-row">
                                    <button type="submit" className="form-submit">Schimbă parola</button>
                                </div>
                            </form>
                        </div>

                        <div className="form-section">
                            <h2>Abonament</h2>
                            <div className="subscription-info">
                                <p>Tip: <b>{user.subscription_type || 'Niciun abonament activ'}</b></p>
                                <p>Status: <b>{user.subscription_status || '-'}</b></p>
                                <p>Expiră la: <b>{user.subscription_expires_at || '-'}</b></p>
                                {user.subscription_type && (
                                    <div className="form-row">
                                        <button onClick={handleCancelSubscription} className="form-submit cancel">Anulează subscripția</button>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="form-section">
                            <h2>Istoric plăți</h2>
                            <div className="payments-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>ID comandă</th>
                                            <th>Suma</th>
                                            <th>Monedă</th>
                                            <th>Status</th>
                                            <th>Data</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {payments.length === 0 && <tr><td colSpan="5">Nu există plăți.</td></tr>}
                                        {payments.map(p => (
                                            <tr key={p.id}>
                                                <td>{p.order_id}</td>
                                                <td>{p.amount}</td>
                                                <td>{p.currency}</td>
                                                <td>{p.status}</td>
                                                <td>{p.created_at}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Account; 